const Login = () => import(/* webpackChunkName: "login-group" */ '@/views/login/Login')
const ResetPassword = () => import(/* webpackChunkName: "login-group" */ '@/views/login/ResetPassword')

export default [
  {
    path: '/',
    name: 'login',
    components: {
      main: Login
    },
    meta: {
      title: '登录'
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    components: {
      main: ResetPassword
    },
    meta: {
      title: '重置密码'
    }
  }
]
